// extracted by mini-css-extract-plugin
export default {"font-renta":"WorkOrdersPendingApproval_font-renta__svFWc"};